export default __webpack_public_path__ + "828922f958f8eaa40aa45bdac50bc05b.png";